import axios from '../plugins/axios'

export default {
    create(params){
      return axios.post('/api/v1/popups/create', params)
    },
    update(params){
        return axios.post('/api/v1/popups/update', params)
    }
}
